/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EventManagementSettingAllSoldResponse } from './EventManagementSettingAllSoldResponse';

export type EventManagementSettingAllSoldResponseApiRespoonse = {
    data?: EventManagementSettingAllSoldResponse;
    status?: EventManagementSettingAllSoldResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace EventManagementSettingAllSoldResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

